module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAECAYAAADMHGwBAAAABGdBTUEAALGPC/xhBQAAARlJREFUKBXVkjtuwzAMhkUpfgT1UgRoDOR8Ra7hTBl7tt7CaJcODuxYttiPaotsGdqpBKifpCQ+fkncHVFVcafT7hrCzqs24lyzpvRgaOqw1VCkEZGKVJuEGn7rLTvJsiOyggv5MhJcuB/JdSU+48/e+x97sriGMAXVkf1JvR81pbHEdkUxuhhH6boP0a6rY0rPKtJysHWqe0MStjT7BBb4d4VzkWas+JIbs+a+9HbPSDERCawbUc1oNrGCOW34X0l1OJR22Yq/MEAC36jWE+th+NUQ5npYeGdvCCIXBh5My3W9sD+YwsgM/kkg1JMAotGyrHiJkp7qeV0r8X5LXzWxLc9YC2gxztbJ7OMx5uJ6Pj/mb5S9/7l8Ag8NiQdi95blAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles/underline_sm@1x.png
// module id = 517
// module chunks = 46